import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { Icon } from 'antd';
import { Container } from './styles';
import {
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper
} from '../TemplateSection/styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import Loader from '../../components/Loader';
import CreateStandaloneReusableSection from '../../components/Modals/CreateStandaloneReusableSection';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { getTemplateStatus } from '../../utils/services/templatesAPI';
import LockStatusCheckModal from '../../components/Modals/LockStatusCheckModal';
import { withTranslation } from 'react-i18next';
import { DOCUMENT_AND_EMAIL_ELEMENTS_LIST } from '../TemplateSection/translationValues';
import { checkLockStatus } from '../../utils/services/complexDocumentsAPI';
import TemplateLockedModal from '../ComplexDocumentDesign/TemplateLockedModal';
import { fetchAllStandaloneBlock } from '../../utils/services/complexEmailAPI';
import { EmailBlockTemplate } from './emailBlockTemplate';

const NAMESPACES = ['DOCUMENT_AND_EMAIL_ELEMENTS_LIST'];
const ReferenceBlocks = props => {
  const {
    isReferenced,
    userpage,
    activeTab,
    elementCategories,
    globalSearchVal,
    globalSearchTag,
    isEmailElements,
    activeContent,
    forApproval,
    t,
    setuserpage,
    setFetchingCategoryList,
  } = props;
  const [selectedElement, setSelectedElement] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedAction, setSelectedAction] = useState(null);
  const [modalVisibility, setModalVisibility] = useState(false);
  const [delmodalVisibility, setDelModalVisibility] = useState(false);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [lockedBy, setLockedBy] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [elementsList, setElementsList] = useState([]);
  const [elementsCount, setElementsCount] = useState(null);
  const { loginVisible, userDetails } = useContext(AppStoreContext);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setElementsList([]);
      const response = await fetchAllStandaloneBlock(
        1,
        isReferenced,
        activeTab,
        globalSearchVal,
        globalSearchTag,
        'write',
        forApproval,
      );
      if (response) {      
          let elementsData = response.data;
          setElementsList(elementsData);
          setElementsCount(response.dataCount);     
      }
      setFetchingCategoryList(false);
      setIsLoading(false);
    })();
    // eslint-disable-next-line
  }, [isReferenced, activeTab, globalSearchVal, globalSearchTag, activeContent, forApproval]);

  useEffect(() => {
    setCategoryList(elementCategories);
  }, [elementCategories]);

  useEffect(() => {
    (async () => {
      if (elementsCount > 0) {
        if (elementsList?.length !== elementsCount) {
          const response = await fetchAllStandaloneBlock(
            userpage,
            isReferenced,
            activeTab,
            globalSearchVal,
            globalSearchTag,
            'write',
            forApproval,
          );

          if (response) {
            let elementsData =
              userpage > 1 ? elementsList.concat(response.data) : response.data;
            setElementsList(elementsData);
            setElementsCount(response.dataCount);
            // }
          }
        }
      }
    })();
    // eslint-disable-next-line
  }, [userpage]);

  useEffect(() => {
    if (
      loginVisible === false &&
      Boolean(selectedElement) &&
      Boolean(selectedElement.id) &&
      !Boolean(selectedAction)
    ) {
      if (isEmailElements) {
        history.push(`/emailElementDesign/${selectedElement.id}`);
      } else {
        history.push(`/elementDesign/${selectedElement.id}`);
      }
    }
  }, [loginVisible, selectedElement, selectedAction, history, isEmailElements]);

  const checkTemplateStatus = async template => {
    const payload = {
      resourceId: template.id,
      resourceType: activeContent === 'createFlow' ? 'flow' : 'block',
    }
    let templateStatus;
    if (isEmailElements) {
      templateStatus = await getTemplateStatus(
        template.id,
        isEmailElements ? 'emailElement' : 'printElement',
      );
    } else {
      templateStatus = await checkLockStatus(payload);
    }
    if (!isEmailElements) {
      if (templateStatus.statusCode === 741) {
        if (userDetails.id !== templateStatus.data.userId) {
          setLockedBy(templateStatus.data.userName);
          setSelectedAction('template-locked');
          setUpdateModalVisibility(true);
          return 'template-locked';
        }
      }
    }

    if (isEmailElements && templateStatus?.data) {
      const { locked, lockedBy } = templateStatus.data;
      if (userDetails && locked && lockedBy) {
        const locked = userDetails.id !== lockedBy.userId;
        if (locked) {
          setLockedBy(lockedBy);
          setSelectedAction('template-locked');
          setUpdateModalVisibility(true);
          return 'template-locked';
        }
      }
    }
  };

  const enableModalVisibility = async (actionType, template) => {
    const checkStatus = ['delete-mail-template'].some(data => data === actionType);
    if (checkStatus) {
      actionType = (await checkTemplateStatus(template)) || actionType;
    }
    setUpdateModalVisibility(true);
    setDelModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedElement(template);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setModalVisibility(false);
    setDelModalVisibility(false);
    setSelectedAction(null);
    setSelectedElement(null);
  };
  const redirectToRefElement = (element) => {
    const blockId = element?.parentBlockId || element?.blockId;
    if (!blockId) return;
  
    const waitingParam = forApproval ? '?waitingForApproval=true' : '';
    history.push(`/complexEmailBlock/${blockId}${waitingParam}`);
  };

  const onSuccessDeletion = async deleted => {
    setDelModalVisibility(false);
    setUpdateModalVisibility(false);
    if (deleted) {
      setIsLoading(true);
      const elementResponse = await fetchAllStandaloneBlock(
        1,
        isReferenced,
        activeTab,
        globalSearchVal,
        globalSearchTag,
        'write')

      if (elementResponse) {
        let elementsData = elementResponse.data;
        setElementsList(elementsData);
        setElementsCount(elementResponse.dataCount);
      }
      setuserpage(1)
      setIsLoading(false);
    }
  };

  const renderBody = (categoriesTemp, templatesList) => {
    return (
      <React.Fragment>
        {templatesList.length > 0 && (
          <>
            <TemplateWrapper>
              {templatesList.map(templateObj => {
                const categoryByTemplate = {
                  id: templateObj.id || templateObj.parentBlockId || templateObj.blockId,
                  name: templateObj.name || templateObj.flowName || templateObj.parentBlockName || templateObj.blockName,
                  categoryId: templateObj.categoryId,
                  type: templateObj.type,
                };
                return (
                  <EmailBlockTemplate
                    templateObj={templateObj}
                    categoriesTemp={categoriesTemp}
                    redirectToTemplate={redirectToRefElement}
                    enableModalVisibility={enableModalVisibility}
                    categoryByTemplate={categoryByTemplate}
                  />
                );
              })}
            </TemplateWrapper>
          </>
        )}
      </React.Fragment>
    );
  };

  return (
    <Container>
      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <TemplateConatiner>
          <>
          <>{elementsCount === 0 ? '' : renderBody(categoryList, elementsList)}</>
          </>
          {!isLoading && modalVisibility && !loginVisible && (
            <CreateStandaloneReusableSection
              visible={modalVisibility}
              onCancel={disableModalVisibility}             
              categoryType="template"
            />
          )}
          {!isLoading && delmodalVisibility && !loginVisible && selectedAction !== 'template-locked' && (
            <DeleteTemplateModal
              visible={delmodalVisibility}
              onCancel={disableModalVisibility}
              targetTemplate={selectedElement}
              categoryType={'element'}
              isElement={true}
              onSucess={onSuccessDeletion}
              activeContent={activeContent}
            />
          )}
          {!isLoading &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            selectedAction === 'template-locked' && isEmailElements && (
              <LockStatusCheckModal
                visible={updateModalVisibility}
                lockedBy={lockedBy}
                onCancel={disableModalVisibility}
              />
            )}
          {!isLoading &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            selectedAction === 'template-locked' && !isEmailElements && (
              <TemplateLockedModal
                visible={selectedAction === 'template-locked'}
                onClose={disableModalVisibility}
                lockedByUser={lockedBy}
                deletion={true} />)}
          {!isLoading && elementsList && elementsList?.length === 0 && (
            <EmptySettingsDetails>
              <div className="empty-illustration">
                <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
              </div>
              <div className="empty-txt" style={{ color: 'black', fontSize: '15px' }}>
                <span style={{ fontWeight: 700 }}></span>
                <span> {t(DOCUMENT_AND_EMAIL_ELEMENTS_LIST.ELEMENTS_LIST_EMPTY_TEXT.key, DOCUMENT_AND_EMAIL_ELEMENTS_LIST.ELEMENTS_LIST_EMPTY_TEXT.value)}</span>
              </div>
            </EmptySettingsDetails>
          )}
          {elementsList && (
            <>
              {elementsList?.length !== elementsCount && (
                <div className="addMore">
                  <Icon type="loading" />
                  {t(DOCUMENT_AND_EMAIL_ELEMENTS_LIST.LOADING_MORE.key, DOCUMENT_AND_EMAIL_ELEMENTS_LIST.LOADING_MORE.value)}
                </div>
              )}
              {elementsList?.length === elementsCount && elementsList?.length !== 0 && (
                <div className="allData">
                  {t(DOCUMENT_AND_EMAIL_ELEMENTS_LIST.GOT_ALL_ELEMENTS_LIST.key, DOCUMENT_AND_EMAIL_ELEMENTS_LIST.GOT_ALL_ELEMENTS_LIST.value)}
                </div>
              )}
            </>
          )}
        </TemplateConatiner>
      )}
    </Container>
  );
};

export default withTranslation(NAMESPACES)(ReferenceBlocks);
